<template>
<div class="page">
    <headerApp :appLinkShow="appLinkShow" wapTitle="拍卖" :spreadID="'0'" :app-link="appLink" :soShow="true" @gotoApp="gotoApp"></headerApp>
    <van-loading v-if="isLoading" />
    <!-- 头部 -->
    <HomeTabs activeTab="5-0" />
    <div class="cbidsBox" @click="gotoApp">
        <div :class="upBtnFlag?'':'lowHight'">
            <template v-for="(item,i) in cbids">
                <div class="cbidsItem" :class="item.tend==1?'redCbids':'greenCbids'" :key="i+'cbids'">
                    <div class="cbidsTitle">{{item.title}}</div>
                    <div class="cbidsCurr">{{item.curr}}</div>
                    <div>{{(item.tend==1?'+':'')+item.valu_fix}}{{' '+(item.tend==1?'+':'')+item.tend_score+'%'}}</div>

                </div>
            </template>
        </div>

        <div class="cbidBtn" @click.stop="upBtnFlag=!upBtnFlag">{{ upBtnFlag?'全部收起':'全部展开' }}</div>
    </div>
    <div class="btnList">
        <!-- <img src="@/assets/img/benlist_bg.png" alt=""> -->
        <div>
            <img @click="gotoApp" src="@/assets/img/quotaicon_1.png" alt="">
            <span>行情对比</span>
        </div>
        <div>
            <img @click="gotoApp" src="@/assets/img/quotaicon_2.png" alt="">
            <span>看报告</span>
        </div>
        <div>
            <img @click="gotoApp" src="@/assets/img/quotaicon_3.png" alt="">
            <span>看解读</span>
        </div>
        <div>
            <img @click="gotoRank" src="@/assets/img/quotaicon_4.png" alt="">
            <span>排行榜</span>
        </div>
    </div>

    <div class="compositeIndexBox" @click="gotoApp">
        <div class="compositeIndexTitle">艺术品市场价格综合指数 <span>更多</span></div>
        <div class="indexTextBox">当前指数 <span>{{indexAuction.curr}}</span>比上期<span>{{'+'+indexAuction.value_fix}}</span><span>{{'+'+indexAuction.tend_num+'%'}}</span></div>
        <div id="myChart" :style="{width: '100%', height: '10rem'}"></div>
    </div>
    <div class="compositeIndexBox" @click="gotoApp">
        <div class="compositeIndexTitle">艺术家指数涨跌榜 <span>更多</span></div>
        <div class="artistIndexList">
            <div v-for="(item,i) in artistIndex" :class="i==0?'actv':''" :key="i+'artistIndex'">{{item.title}}</div>
        </div>
        <div class="redBox">
            <div class="leftBox">
                <template v-for="(item,i) in artistIndex[0].ranking_desc">
                    <div v-if="i<4" :class="'redLeftBox'+i" :key="i+'artistIndexBox'">
                        <div>{{ item.name }}</div>
                        <div>{{ item.ratestr }}</div>
                    </div>
                </template>
            </div>
            <div class="rightBox">
                <template v-for="(item,i) in artistIndex[0].ranking_desc">
                    <div v-if="i>3" :class="'redRightBox'+i" :key="i+'artistIndexBox'">
                        <div>{{ item.name }}</div>
                        <div>{{ item.ratestr }}</div>
                    </div>
                </template>
            </div>
        </div>
        <div class="greenBox">
            <div class="leftBox">
                <template v-for="(item,i) in artistIndex[0].ranking_asc">
                    <div v-if="i<4" :class="'redLeftBox'+i" :key="i+'artistIndexBox'">
                        <div>{{ item.name }}</div>
                        <div>{{ item.ratestr }}</div>
                    </div>
                </template>
            </div>
            <div class="rightBox">
                <template v-for="(item,i) in artistIndex[0].ranking_asc">
                    <div v-if="i>3" :class="'redRightBox'+i" :key="i+'artistIndexBox'">
                        <div>{{ item.name }}</div>
                        <div>{{ item.ratestr }}</div>
                    </div>
                </template>
            </div>

        </div>
    </div>
    <div class="compositeIndexBox" @click="gotoApp">
        <div class="compositeIndexTitle">艺术品指数</div>
        <template v-for="(item,i) in auctionIndex">
            <div :key="i+'auctionIndex'" class="auctionBox">
                <div class="auctionImg"><img :src="item.pic" alt=""></div>
                <div class="auctionText">
                    <div class="auctionTitle">{{item.title}}</div>
                    <div class="auctionDesc">
                        <div :class="item.tend==1?'redAuction':'greenAuction'">
                            <div>{{item.curr}}</div>
                            <div>{{(item.tend==1?'+':'')+item.tend_num+'%'}}</div>
                        </div>
                        <div :id="'auctionIndex'+i" class="auctionCharts">
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <div class="compositeIndexBox" @click="gotoApp">
        <div class="compositeIndexTitle">行情趋势对比 </div>
        <div id="contrastChart" :style="{width: '100%', height: '12rem'}"></div>
    </div>
    <div class="compositeIndexBox" @click="gotoApp">
        <div class="compositeIndexTitle">行情参考 </div>
        <div class="confidenceTitle">
            <div class="confidenceLeft">信息指数</div>
            <div class="confidenceRight">景气指数</div>
        </div>
        <div class="indexTextBox">当前指数 <span>{{confidence_index.curr}}</span>比上期<span>{{'+'+confidence_index.diff}}</span><span>{{'+'+confidence_index.tend_num+'%'}}</span></div>
        <div id="confidenceCharts" :style="{width: '100%', height: '10rem'}"></div>

    </div>
    <div class="questionnaire" @click="gotoApp">
        <img src="@/assets/img/confidence.png" alt="">
    </div>

    <DownLoadApp ref="downloadPop"></DownLoadApp>
</div>
</template>

<script>
import {
    getAmma
} from "@/api/index";
import DownLoadApp from '@/components/common/downloadApp'
import headerApp from "@/components/headerApp";
import HomeTabs from '@/components/HomeTabs.vue'
export default {
    components: {
        HomeTabs,
        headerApp,
        DownLoadApp
    },
    data() {
        return {
            num: 0,
            classNum: 0,
            isMem: 0,
            isLoading: true,
            upBtnFlag: false,
            appLinkShow: true,
            auctionIndex: [],
            market: [],
            market_time_line: [],
            confidence_index: [],
            cbids: [],
            indexAuction: {},
            artistIndex: [{
                ranking_desc: [],
                ranking_asc: []
            }],
            // 通链接数据
            appLink: '/2/8/0',
        }
    },
    methods: {
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0)
        },
        gotoRank() {
            this.$router.push({
                path: '/rankList?active=0',
            });
        },

        goBack() {
            if (document.referrer) {
                window.location.href = document.referrer
            } else if (window.history.state) {
                this.$router.back()
            } else if (this.$route.query.fromlink) {
                window.location.href = decodeURIComponent(this.$route.query.fromlink)
            } else {
                this.$router.push({
                    path: "/"
                });
            }
        },
        getAmmaFun() {
            let echarts = require('echarts/lib/echarts');
            let that = this;
            getAmma().then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    this.cbids = data.cbids
                    this.indexAuction = data.index_auction
                    this.artistIndex = data.artist_index
                    this.auctionIndex = data.auction_index
                    this.market = data.market
                    this.market_time_line = data.market_time_line
                    this.confidence_index = data.confidence_index

                    this.isLoading = false;
                    setTimeout(function () {
                        for (let i in that.auctionIndex) {
                            let auctionChart = that.$echarts.init(document.getElementById('auctionIndex' + i));
                            auctionChart.setOption({
                                title: {
                                    text: "",
                                    show: false
                                },
                                grid: {
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    containLabel: false
                                },
                                tooltip: {},
                                xAxis: {
                                    show: false,
                                    data: that.auctionIndex[i].index
                                },
                                yAxis: {
                                    show: false
                                },
                                series: [{
                                    name: '',
                                    type: 'line',
                                    showSymbol: false,
                                    itemStyle: {
                                        color: that.auctionIndex[i].tend == 1 ? '#D33931' : '#1BBA75'
                                    },
                                    data: that.auctionIndex[i].list
                                }]
                            });
                        }
                    }, 500)

                    let confidenceCharts = this.$echarts.init(document.getElementById('confidenceCharts'));
                    confidenceCharts.setOption({
                        title: {
                            text: ""
                        },
                        grid: {
                            left: 0,
                            right: 0,
                            top: 10,
                            bottom: 0,
                            containLabel: true
                        },
                        tooltip: {},
                        xAxis: {
                            data: this.confidence_index.auction_season
                        },
                        yAxis: {},
                        series: [{
                            name: '',
                            type: 'line',
                            itemStyle: {
                                color: '#1BBA75'
                            },
                            areaStyle: {
                                areaStyle: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: '#83bff6'
                                        },
                                        {
                                            offset: 0.5,
                                            color: '#188df0'
                                        },
                                        {
                                            offset: 1,
                                            color: '#188df0'
                                        }
                                    ])
                                },
                            },
                            data: this.confidence_index.list
                        }]
                    });

                    let contrastChart = this.$echarts.init(document.getElementById('contrastChart'));
                    contrastChart.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            icon: 'rect',
                            data: ['黄金指数', '古代书画指数', '近现代书画指数', '当代书画指数']
                        },
                        grid: {
                            left: '0%',
                            right: '0%',
                            top: '25%',
                            bottom: '0%',
                            containLabel: true
                        },
                        toolbox: {
                            feature: {
                                saveAsImage: {}
                            }
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: that.market_time_line
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                                name: '黄金指数',
                                type: 'line',
                                itemStyle: {
                                    color: '#FCA115'
                                },
                                stack: 'Total',
                                data: that.market[0].list[0].list
                            },
                            {
                                name: '古代书画指数',
                                type: 'line',
                                itemStyle: {
                                    color: '#359AF6'
                                },
                                stack: 'Total',
                                data: that.market[2].list[0].list
                            },
                            {
                                name: '近现代书画指数',
                                type: 'line',
                                itemStyle: {
                                    color: '#9B7AFD'
                                },
                                stack: 'Total',
                                data: that.market[2].list[1].list
                            },
                            {
                                name: '当代书画指数',
                                type: 'line',
                                itemStyle: {
                                    color: '#FE5065'
                                },
                                stack: 'Total',
                                data: that.market[2].list[2].list
                            }
                        ]
                    });
                    let myChart = this.$echarts.init(document.getElementById('myChart'));
                    myChart.setOption({
                        title: {
                            text: ""
                        },
                        grid: {
                            left: 0,
                            right: 0,
                            top: 10,
                            bottom: 0,
                            containLabel: true
                        },
                        tooltip: {},
                        xAxis: {
                            data: this.indexAuction.labe_line
                        },
                        yAxis: {},
                        series: [{
                            name: '',
                            type: 'line',
                            itemStyle: {
                                color: '#1BBA75'
                            },
                            areaStyle: {
                                areaStyle: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: '#83bff6'
                                        },
                                        {
                                            offset: 0.5,
                                            color: '#188df0'
                                        },
                                        {
                                            offset: 1,
                                            color: '#188df0'
                                        }
                                    ])
                                },
                            },
                            data: this.indexAuction.valu_line
                        }]
                    });
                }
            });
        },
    },
    mounted() {

        // this.showWater = [1, 2].includes(Number(from))
        document.title = ""
        this.getAmmaFun()
    }
}
</script>

<style lang="scss" scoped>
.page {
    .questionnaire {
        background: #fff;
        margin-top: -0.2rem;
        padding-top: 2rem;

        img {
            width: 100%;
        }
    }

    .compositeIndexBox {
        padding: 1rem;
        width: 100%;
        background: #fff;
        margin-bottom: 0.2rem;

        .confidenceTitle {
            width: 100%;
            text-align: center;

            .confidenceLeft {
                background: #17BC70;
                color: #fff;
                border: 1px solid #17BC70;
                border-top-left-radius: 0.3rem;
                border-bottom-left-radius: 0.3rem;
                margin-right: -0.2rem;
            }

            .confidenceRight {
                border-top-right-radius: 0.3rem;
                border-bottom-right-radius: 0.3rem;

            }

            div {
                box-sizing: border-box;
                border: 1px solid #DFDFDF;
                padding: 0.3rem 0.7rem;
                display: inline-block;
            }
        }

        .auctionBox {
            width: 100%;
            margin: 1rem 0;

            .auctionText {
                vertical-align: top;
                display: inline-block;
                width: calc(65% - 0.5rem);
                margin-left: 0.5rem;

                .auctionTitle {
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                }

                .auctionDesc {
                    width: 100%;
                    margin-top: 0.5rem;

                    .redAuction {
                        width: 65%;
                        color: #D33931;
                        display: inline-block;
                    }

                    .greenAuction {
                        width: 65%;
                        color: #27B577;
                        display: inline-block;
                    }

                    .auctionCharts {
                        background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
                        width: 30%;
                        display: inline-block;
                        height: 2rem;
                    }

                }
            }

            .auctionImg {
                width: 30%;
                border-radius: 0.3rem;
                display: inline-block;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .redBox {
            width: 100%;

            .leftBox {
                width: 60%;
                display: inline-block;

                .redLeftBox0 {
                    width: calc(60% - 0.1rem);
                    display: inline-block;
                    background: #FE5165;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    border-top-left-radius: 0.5rem;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redLeftBox1 {
                    width: calc(40% - 0.1rem);
                    display: inline-block;
                    background: #FE6172;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redLeftBox2 {
                    width: calc(40% - 0.1rem);
                    display: inline-block;
                    background: #FE6172;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redLeftBox3 {
                    width: calc(60% - 0.1rem);
                    display: inline-block;
                    background: #FE6172;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }
            }

            .rightBox {
                width: 40%;
                margin-left: -0.2rem;
                display: inline-block;

                .redRightBox4 {
                    width: 100%;
                    display: inline-block;
                    background: #FF7988;
                    color: #fff;
                    line-height: 1.8rem;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    border-top-right-radius: 0.5rem;
                    margin-bottom: 0.1rem;

                    div {
                        text-align: center;
                        display: inline-block;
                    }
                }

                .redRightBox5 {
                    width: calc(50% - 0.1rem);
                    display: inline-block;
                    background: #FE5165;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redRightBox6 {
                    width: 50%;
                    display: inline-block;
                    background: #FE5165;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    border-bottom-right-radius: 0.5rem;
                    margin-bottom: 0.1rem;
                }
            }
        }

        .greenBox {
            width: 100%;
            margin-top: 0.7rem;

            .leftBox {
                width: 60%;
                display: inline-block;

                .redLeftBox0 {
                    width: calc(60% - 0.1rem);
                    display: inline-block;
                    background: #11B76B;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    border-top-left-radius: 0.5rem;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redLeftBox1 {
                    width: calc(40% - 0.1rem);
                    display: inline-block;
                    background: #11B76B;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redLeftBox2 {
                    width: calc(40% - 0.1rem);
                    display: inline-block;
                    background: #11B76B;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redLeftBox3 {
                    width: calc(60% - 0.1rem);
                    display: inline-block;
                    background: #11B76B;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }
            }

            .rightBox {
                width: 40%;
                margin-left: -0.2rem;
                display: inline-block;

                .redRightBox4 {
                    width: 100%;
                    display: inline-block;
                    background: #39C684;
                    color: #fff;
                    line-height: 1.8rem;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    border-top-right-radius: 0.5rem;
                    margin-bottom: 0.1rem;

                    div {
                        text-align: center;
                        display: inline-block;
                    }
                }

                .redRightBox5 {
                    width: calc(50% - 0.1rem);
                    display: inline-block;
                    background: #39C684;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    margin-right: 0.1rem;
                    margin-bottom: 0.1rem;
                }

                .redRightBox6 {
                    width: 50%;
                    display: inline-block;
                    background: #39C684;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 0.5rem 0.5rem;
                    box-sizing: border-box;
                    border-bottom-right-radius: 0.5rem;
                    margin-bottom: 0.1rem;
                    float: right;

                    div {
                        width: 100%;
                        white-space: nowrap;
                        /* 不换行 */
                        overflow: hidden;
                        /* 溢出隐藏 */
                        text-overflow: ellipsis;
                        /* 显示省略号 */

                    }
                }
            }
        }

        .artistIndexList {
            width: 100%;
            margin: 0.5rem 0;

            .actv {
                background: #18BC70;
                color: #fff;
            }

            div {
                background: #F0F1F3;
                color: #000;
                padding: 0.3rem 0.6rem;
                margin-right: 0.5rem;
                border-radius: 0.3rem;
                display: inline-block;
            }
        }

        .indexTextBox {
            text-align: center;
            margin: 0.5rem 0;

            span {
                font-size: 0.8rem;
                display: inline-block;
                margin: 0 0.5rem;
                color: #E13033;
                font-weight: bolder;
            }
        }

        .compositeIndexTitle {
            font-size: 0.7rem;
            font-weight: bolder;
            color: #323232;

            span {
                display: block;
                float: right;
                color: #656565;
            }
        }
    }

    .btnList {
        margin: 0.2rem 0;
        width: 100%;
        height: 5.6rem;
        background: #fff;
        display: flex;
        justify-content: space-around;
        align-items: center;

        div{
            text-align: center;
        }

        img {

            width: 2.4rem;
            height: auto;
        }
        span{
            margin-top: 5px;
            font-weight: 400;
            font-size: 0.6rem;
            color: #000000;
            display: block;
        }
    }

    .cbidsBox {

        background: #fff;
        width: 100%;

        .lowHight {
            height: 4.5rem;
            overflow: hidden;
        }

        .cbidBtn {
            width: 100%;
            text-align: center;
            font-size: 0.6rem;
            padding: 1rem 0;
            color: #B2B2B2;

        }

        .cbidsItem {
            width: 30%;
            border-radius: 0.5rem;
            margin: 0.2rem 1.5%;
            text-align: center;
            border: 1px solid #eee;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
            display: inline-block;
            padding: 0.3rem;

            .cbidsTitle {
                font-size: 0.7rem;
                color: #000;
            }

            .cbidsCurr {
                font-size: 0.8rem;
                font-weight: bolder;
            }
        }

        .redCbids {
            color: #E13033;
        }

        .greenCbids {
            color: #15BA6B;
        }

    }

    /deep/.van-loading {
        position: fixed;
        background-color: #fff;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 400;

        .van-loading__spinner {
            position: absolute;
            width: 3rem;
            height: 3rem;
            left: 50%;
            top: 50%;
            margin: -1.5rem 0 0 -1.5rem;
        }
    }
}
</style>
